export default __webpack_public_path__ + "static/media/EM0333.34I-41677_-24952_0.c96f318f.jpg";